// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"99":"LazyGoogleOneTap","873":"LazyIdentificationForm"}[chunkId] + "." + {"99":"7f5b97d367f9d7ed92cd","873":"da27f1764ee4dbdb8870"}[chunkId] + ".js";
};